<script>
    import { fade } from 'svelte/transition';
    import Fa from "svelte-fa";
    import SelectImage from "./SelectImage.svelte";
    import { business } from "../../firebase/auth";
    import { faPen } from "@fortawesome/free-solid-svg-icons";

    export let size = 100;

    let edit = false;
</script>


{#if edit === true}
    <SelectImage
        type = "avatar"
        name = "Profilbild"
        imgSize = {{x: 360, y: 360}}
        businessId = {$business.id}
        on:cancel={() => {edit = false}}
        on:confirm={() => {edit = false}}
    />
{/if}
<button on:click={() => {edit = true}}>
    <div class="img-wrapper gradient" style="width: {size}px; height: {size}px">
        {#if $business.images?.avatar}
            <img src="{$business.images?.avatar??""}" alt="Avatar" width={size} height={size} style="width: {size}px; height: {size}px" in:fade="{{duration: 400}}" draggable="false">
        {/if}
    </div>
    <div class="edit">
        <Fa
            icon={faPen}
            slot="icon"
        />
    </div>
</button>


<style>
    .edit {
        pointer-events: none;
        position: absolute;
        bottom: 0;
        right: 0;
        padding: 0.75rem;
        border-radius: 9999rem;
        background-color: #F5F2EF;
        line-height: 1rem;
    }

    button {
        padding: 0;
        border-radius: 50%;
        cursor: pointer;
    }

    .img-wrapper {
        display: block;
        padding: 0;
        font-size: 0;
        background-color: white;
        border-radius: 50%;
        overflow: hidden;
        outline: 4px solid white;
        background-color: #ebe6e2;
    }
</style>
